import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

import { FlowchartComponent }     from '@shared/ui/flowchart/flowchart.component';
import { FlowchartItemComponent } from '@shared/ui/flowchart-item/flowchart-item.component';
import { MindmapComponent }       from '@shared/ui/mindmap/mindmap.component';
import { MindmapBranchComponent } from '@shared/ui/mindmap-branch/mindmap-branch.component';
import { WordcloudComponent }     from '@shared/ui/wordcloud/wordcloud.component';
import { WordcloudWordComponent } from '@shared/ui/wordcloud-word/wordcloud-word.component';
import { PipesModule }            from '@shared/pipes/pipes.module';
import { IconsModule }            from '@shared/icons/icons.module';


@NgModule({
  declarations: [
    FlowchartComponent,
    FlowchartItemComponent,
    MindmapComponent,
    MindmapBranchComponent,
    WordcloudComponent,
    WordcloudWordComponent,
  ],
  imports:      [
    CommonModule,
    PipesModule,
    IconsModule
  ],
  exports:      [
    FlowchartComponent,
    FlowchartItemComponent,
    MindmapComponent,
    MindmapBranchComponent,
    WordcloudComponent,
    WordcloudWordComponent,
  ]
})
export class UiModule {}
